const en = {
  // Site
  siteName: "Ryukyu GLOCAL Kids",
  siteSubtitle: "Summer School 2026",
  welcome: "Welcome to Ryukyu GLOCAL Kids, Summer School 2026",
  welcomeSubtitle: "Learn. Build. Pitch. Celebrate!",

  // Nav
  home: "Home",
  myProfile: "My Profile",
  dashboard: "Dashboard",
  logout: "Logout",
  login: "Login",

  // Programs
  programs: "Programs",
  kidsEntrepreneurship: "Kids Entrepreneurship",
  aiLiteracy: "AI Literacy",
  publicPresentation: "Public Presentation",
  eSports: "E-Sports",
  vedicMathematics: "Vedic Mathematics",
  robotics: "Robotics",
  comingSoon: "Coming Soon",

  // Login
  studentLogin: "Student Login",
  teacherLogin: "Teacher / Staff Login",
  enterCode: "Enter your 6-digit code",
  enterEmail: "Email address",
  enterPassword: "Password",
  loginBtn: "Login",
  forgotPassword: "Forgot password?",
  backToLogin: "Back to login",
  invalidCode: "Invalid code. Please check and try again.",
  loginSuccess: "Welcome back!",

  // Days
  day1: "Day 1 · Monday",
  day2: "Day 2 · Tuesday",
  day3: "Day 3 · Wednesday",
  day4: "Day 4 · Thursday",
  day5: "Day 5 · Friday",
  theme1: "The Big Idea",
  theme2: "Know Your Customer",
  theme3: "Build It & Brand It",
  theme4: "Money & Market",
  theme5: "Pitch Day!",

  // Stamps
  stamps: "Stamps",
  morning: "Morning",
  afternoon: "Afternoon",
  stampEarned: "Stamp earned!",
  noStampYet: "Not yet earned",
  totalStamps: "Total Stamps",
  outOf: "out of",
  sessions: "sessions",
  giveStamp: "Give Stamp",
  stampGiven: "Stamp given!",

  // Activities
  activity: "Activity",
  worksheet: "Worksheet",
  completed: "Completed",
  notCompleted: "Not yet",
  saveProgress: "Save Progress",
  saved: "Saved!",

  // Profile
  studentProfile: "Student Profile",
  enrolledIn: "Enrolled in",
  weekProgress: "Week Progress",
  myBusinessIdea: "My Business Idea",
  problemSolving: "Problem I'm Solving",
  myIdea: "My Idea",
  myCustomer: "My Customer",
  myPrice: "My Price",
  businessName: "Business Name",
  slogan: "Slogan",

  // Awards
  awards: "Recognition Awards",
  mostCreative: "Most Creative Idea",
  mostCustomerFocused: "Most Customer-Focused",
  bestBrand: "Best Brand & Logo",
  bestProblemSolver: "Best Problem Solver",
  bravestPitcher: "Bravest Pitcher",
  mostImproved: "Most Improved Idea",
  bestTeamPlayer: "Best Team Player",
  mostLikelyToSucceed: "Most Likely to Succeed",

  // Certificate
  certificate: "Certificate of Completion",
  certText: "This certifies that",
  certText2: "has successfully completed the",
  certText3: "Ryukyu GLOCAL Kids Summer School 2026",
  certText4: "Kids Entrepreneurship Program",
  certDate: "Summer 2026, Okinawa, Japan",
  printCertificate: "Print Certificate",
  printBooklet: "Print Booklet",

  // Teacher Dashboard
  teacherDashboard: "Teacher Dashboard",
  allStudents: "All Students",
  lastActivity: "Last Activity",
  viewProfile: "View Profile",
  giveAward: "Give Award",
  selectDay: "Select Day",
  selectSession: "Select Session",

  // Admin
  adminDashboard: "Admin Dashboard",
  inviteTeacher: "Invite Teacher",
  addStudent: "Add Student",
  totalTeachers: "Total Teachers",
  totalStudents: "Total Students",
  totalStampsGiven: "Stamps Given",
  sendInvite: "Send Invitation",
  teacherEmail: "Teacher's email address",

  // Misc
  loading: "Loading...",
  error: "Something went wrong",
  notFound: "Page not found",
  backHome: "Back to Home",
  okinawa: "Okinawa, Japan",
};

export default en;
